import { TranslateString } from '@/types/translation.types';

interface updateTranslateKeyProps {
  translateString: TranslateString | string;
  input: string;
  baseLanguage: string;
  language: string | null;
  doNotChange?: boolean;
}

export function updateTranslateKey({
  translateString,
  input,
  baseLanguage,
  language,
  doNotChange,
}: updateTranslateKeyProps): TranslateString {
  if (!translateString) {
    translateString = { base: '', changed: '' };
  }

  if (typeof translateString === 'string') {
    translateString = { base: translateString, changed: '' };
  }

  if (language && language !== baseLanguage) {
    const updated = (translateString.overrides ?? []) as string[];

    return {
      ...translateString,
      [language]: input,
      overrides: Array.from(new Set([...updated, language]).values()),
    };
  } else if (language) {
    return {
      ...translateString,
      [language]: input,
      base: input,
      changed: doNotChange ? '' : 'true',
    };
  } else {
    return {
      ...translateString,
      base: input,
      changed: 'true',
    };
  }
}
